import { render } from "./QuoteAddItemModal.vue?vue&type=template&id=535d4405&scoped=true&ts=true&lang=pug"
import script from "./QuoteAddItemModal.vue?vue&type=script&lang=ts"
export * from "./QuoteAddItemModal.vue?vue&type=script&lang=ts"

import "./QuoteAddItemModal.vue?vue&type=style&index=0&id=535d4405&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535d4405"]])

export default __exports__